import { render, staticRenderFns } from "./PlanDirection.vue?vue&type=template&id=2b4c5d97&scoped=true&lang=pug&"
import script from "./PlanDirection.vue?vue&type=script&lang=js&"
export * from "./PlanDirection.vue?vue&type=script&lang=js&"
import style0 from "./PlanDirection.vue?vue&type=style&index=0&id=2b4c5d97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c5d97",
  null
  
)

export default component.exports